/**
 * DIPS OAuth リダイレクトページ
 *
 * DIPS2.0認証後のコールバックを処理し、
 * 認可コードをアクセストークンに交換する
 */

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { dipsApi } from '../services/api';
import { Card, Button, Alert } from '../components/ui';
import { Icon } from '../components/icons';

export default function DipsRedirect() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('processing'); // processing | success | error
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setStatus('error');
      setError(`DIPS認証エラー: ${searchParams.get('error_description') || errorParam}`);
      return;
    }

    if (!code) {
      setStatus('error');
      setError('認可コードが見つかりません');
      return;
    }

    // stateからapiTypeを抽出（形式: "apiType:uuid"）
    let apiType = 'aircraft';
    if (state && state.includes(':')) {
      apiType = state.split(':')[0];
    }
    console.log('[DipsRedirect] Detected apiType from state:', apiType);

    // トークン交換を実行
    const exchangeToken = async () => {
      try {
        console.log('[DipsRedirect] Exchanging token with code:', code?.substring(0, 10) + '...', 'apiType:', apiType);
        const result = await dipsApi.exchangeToken(code, apiType);
        console.log('[DipsRedirect] Token exchange successful');
        setStatus('success');

        // 親ウィンドウにトークンを送信（異なるオリジンでも動作）
        console.log('[DipsRedirect] window.opener:', window.opener ? 'exists' : 'null');
        if (window.opener) {
          const message = {
            type: 'DIPS_AUTH_SUCCESS',
            apiType,
            accessToken: result.accessToken,
            refreshToken: result.refreshToken,
            expiresIn: result.expiresIn,
          };
          console.log('[DipsRedirect] Sending postMessage to parent, apiType:', apiType);
          window.opener.postMessage(message, '*');
          console.log('[DipsRedirect] postMessage sent');
        } else {
          console.warn('[DipsRedirect] No window.opener - cannot send postMessage');
          // window.openerがない場合でも、localStorageにトークンは保存済み（exchangeToken内で実行）
        }

        // 1秒後に自動的にウィンドウを閉じる
        setTimeout(() => {
          window.close();
        }, 1000);
      } catch (err) {
        console.error('[DipsRedirect] Token exchange error:', err);
        setStatus('error');
        setError(err.message);

        // エラーも親ウィンドウに通知
        if (window.opener) {
          window.opener.postMessage({
            type: 'DIPS_AUTH_ERROR',
            error: err.message,
          }, '*');
        }
      }
    };

    exchangeToken();
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <div className="text-center py-8">
          {status === 'processing' && (
            <>
              <div className="w-16 h-16 mx-auto mb-4 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
              <h2 className="text-xl font-bold text-slate-900 mb-2">DIPS認証処理中</h2>
              <p className="text-slate-500">トークンを取得しています...</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 mx-auto mb-4 bg-emerald-100 rounded-full flex items-center justify-center">
                <Icon name="checkCircle" className="w-10 h-10 text-emerald-500" />
              </div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">認証完了</h2>
              <p className="text-slate-500 mb-4">
                DIPS2.0との連携が完了しました。<br />
                このウィンドウは自動的に閉じます。
              </p>
              <Button variant="secondary" onClick={() => window.close()}>
                閉じる
              </Button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full flex items-center justify-center">
                <Icon name="alertCircle" className="w-10 h-10 text-red-500" />
              </div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">認証エラー</h2>
              <Alert variant="error" className="text-left mb-4">
                {error}
              </Alert>
              <Button variant="secondary" onClick={() => window.close()}>
                閉じる
              </Button>
            </>
          )}
        </div>
      </Card>
    </div>
  );
}
